import React from "react";
import "../Css/Njs.css";

// import { PyFooter } from "./PyFooter";
import { useState, useEffect } from "react";
import { DotLoader } from "react-spinners";
import { Navbar } from "../Components/Nav";
import { NFooter } from "./NFooter";

const override = {
  display: "block",
  margin: "auto",
  borderColor: "red",
};

export const NjsFirstStep = () => {
  const [loading, setLoading] = useState(false);
  let [color, setColor] = useState("#FF8C00");

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);
  return (
    <>
      <div className="App">
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              paddingTop: "210px",
            }}
          >
            <DotLoader
              color={color}
              loading={loading}
              cssOverride={override}
              size={100}
            />
          </div>
        ) : (
          <>
            <div class="container-fluid background_node">
              <div className="row">
                <Navbar />
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div>
                    <img
                      className="logo"
                      src={process.env.PUBLIC_URL + "assets/images/njslogo.png"}
                      width="85%"
                      alt="pylogo"
                      height="auto"
                    />
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>

            <div
              class="container-fluid"
              style={{
                backgroundColor: "black",
                paddingTop: "60px",
              }}
            >
              <div className="row mt-2">
                <h1 className="py_h1">NodeJS – First Step</h1>

                <div>
                  <p>
                    We will learn here how to write and run NodeJS. Before you
                    start, you should have NodeJS installed on your computer.
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Install NodeJS In Windows</h1>
                <div>
                  <p>
                    The Node can be installed in multiple ways on a computer.
                    The approach used by you depends on the existing development
                    environment in the system. There are different package
                    installer for different environments. You can install Node
                    by grabbing a copy of the source code and compiling the
                    application. Another way of installing Node is by cloning
                    the GIT repository in all the three environments and then
                    installing it on the system.The first step to install
                    Node.js on windows is to download the installer. Visit the
                    official Node.js website i.e
                    <span
                      style={{
                        color: "orange",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      <a href="https://nodejs.org/en/download/">
                        https://nodejs.org/en/download/
                      </a>
                    </span>
                    and download the .msi file according to your system
                    environment (32-bit & 64-bit). An MSI installer will be
                    downloaded on your system.
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Installation of Node.js on Linux</h1>
                <div>
                  <p>
                    Node.js is a JavaScript runtime built on Chrome’s V8
                    JavaScript engine. Node.js can be installed in multiple ways
                    on your Ubuntu Linux machine. You can use Ubuntu’s official
                    repository to install Node.js or another way to use
                    NodeSource repository. Installation via NodeSource
                    repository will allow you to choose latest version of
                    Node.js. Installing Node On Ubuntu 18.04 and 16.04: There
                    are two methods Ubuntu official repository and NodeSouce
                    repository to install Node.js on Ubuntu. Install Node.js
                    using Ubuntu official repository: Node.js is available in
                    Ubuntu’s repository and you can easily install it using a
                    few commands. Follow the steps below to install Node.js on
                    your Ubuntu operating system.
                    {/* <span
                      style={{
                        color: "orange",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      <a href="https://nodejs.org/en/download/">
                        https://nodejs.org/en/download/
                      </a>
                    </span>
                    and download the .msi file according to your system
                    environment (32-bit & 64-bit). An MSI installer will be
                    downloaded on your system. */}
                  </p>
                </div>
              </div>
              <div className="bg-primary" style={{ fontWeight: "bolder" }}>
                <p className="text-light">sudo apt install nodejs</p>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">NodeJs Version Check</h1>
                <p>
                  {" "}
                  Run below command from terminal or cmd to check NodeJs
                  installed on your PC and version of NodeJs.
                </p>
              </div>

              <div className="bg-primary" style={{ fontWeight: "bolder" }}>
                <p className="text-light">node --version </p>
              </div>
              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Basic Of NodeJs.</h1>
                <p>
                  Node.js is a cross-platform JavaScript runtime environment. It
                  allows the creation of scalable Web servers without threading
                  and networking tools using JavaScript and a collection of
                  “modules” that handle various core functionalities. It can
                  make console-based and web-based node.js applications.
                </p>

                <div className="col-md-6" style={{ color: "white" }}>
                  <span
                    style={{
                      color: "orange",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Datatypes:
                  </span>{" "}
                  Node.js contains various types of data types similar to
                  JavaScript.
                  <ul>
                    <li>Boolean</li>
                    <li>Undefined</li>
                    <li>Null</li>
                    <li>String</li>
                    <li>Number</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <span
                    style={{
                      color: "orange",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Loose Typing:
                  </span>
                  <p>
                    Node.js supports loose typing, it means you don’t need to
                    specify what type of information will be stored in a
                    variable in advance. We use var keyword in Node.js to
                    declare any type of variable.{" "}
                  </p>
                </div>
              </div>

              <hr style={{ color: "white" }} />
              <div className=" row mt-4">
                <h1 className="py_h1">Node.js First Application</h1>
                <p>
                  {" "}
                  Node.js is an open source, cross-platform server environment
                  which executes JavaScript using V8 JavaScript Engine. Node.js
                  helps to write front-end and back-end code in the same
                  language. It helps to write efficient code for real-time
                  applications. In Node.js, the applications can be written
                  using console-based method or web-based method.
                  <br />
                  <br />
                  <span
                    style={{
                      color: "orange",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    Console based Node.js Application:{" "}
                  </span>
                  The Node.js console-based applications are run using Node.js
                  command prompt. Console module in Node.js provide a simple
                  debugging console. Node.js is a global console which can be
                  used for synchronous as well as asynchronous communication.
                  The console.log() function is used to display output on
                  console. This function prints output to stdout with newline.
                </p>
                <div className="col-md-3"></div>
                <div className="col-md-6" style={{ color: "white" }}>
                  <div
                    // className="bg-info"
                    style={{
                      textAlign: "center",
                      backgroundColor: "#5d7b89",
                      fontFamily: "Fira Mono",

                      fontWeight: "bolder",
                    }}
                  >
                    <h3>Example </h3>
                  </div>
                  <pre>
                    <code>
                      {`
                     var http = require('http');
                      http.createServer(function (req, res) {
                         res.writeHead(200, {'Content-Type': 'text/html'});
                         res.end('Hello World!');
                       }).listen(8080);
                       `}
                    </code>
                  </pre>
                </div>
                <div className="col-md-3"></div>

                <div className="bg-primary">
                  <p>
                    Note-: Save the file on your computer: C:\Users\Your
                    Name\myfirst.js <br />
                    The code tells the computer to write "Hello World!" if
                    anyone (e.g. a web browser) tries to access your computer on
                    port 8080.
                  </p>
                </div>
              </div>
            </div>
            <NFooter />
          </>
        )}
      </div>
    </>
  );
};
